import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import constants from '../../constants/Constants';
import { COOKIE, getCookie } from '../../services/Cookie';
import { fronturls } from '../../constants/FrontendURLs';

const PageNotFound = () => {
	const navigate = useNavigate();
	const userType = getCookie(COOKIE.UserType);
  const isAdmin = userType === '1'

	const handleBackHomeClick = () => {
		navigate(isAdmin? fronturls.AdminDashboard: fronturls.StudentDashboard);
	};

	return (
		<div className='min-h-[calc(100vh-133px)] lg:min-h-[calc(100vh-112px)] grid place-content-center place-items-center'>
			<Result
				status="404"
				title="404"
				subTitle="Sorry, the page you visited does not exist."
				extra={<Button type="primary" onClick={handleBackHomeClick}>{constants.BackHome}</Button>}
			/>
		</div>
	);
};

export default PageNotFound;
